export default __webpack_public_path__ + "static/media/Winter_25.83048b54.png";